import { CALL_API } from '../middleware';
import {
    FETCH_FUND_TRANSACTION_DETAILS,
    FETCH_FUND_TRANSACTION_DETAILS_SUCCESS,
    REDEEM_SCHEME,
    REDEEM_SCHEME_SUCCESS,
    SWITCH_SCHEME,
    SWITCH_SCHEME_SUCCESS,
    GET_INVESTOR_LATEST_DETAILS,
    GET_INVESTOR_LATEST_DETAILS_SUCCESS,
    schemeDetailsResponseType,
    GET_INVESTOR_LATEST_DETAILS_FAILED,
    schemeDetailsRequestType,
    RTA_SCHEME_DETAIL_SUCCESS,
    STP_TRANSACTION_SUCCESS,
    STP_TRANSACTION,
    SIP_SUMMARY_SUCCESS,
    SIP_SUMMARY,
    SIP_TRANSACTION_SUCCESS,
    SIP_TRANSACTION,
    SIP_VALIDATION_SUCCESS,
    SIP_VALIDATION,
    SIP_SUBMIT_SUCCESS,
    SIP_SUBMIT,
    OTM_CANCEL_API,
    OTM_CANCEL_API_SUCCESS,
    SIP_CANCEL_REASON,
    SIP_CANCEL_REASON_SUCCESS,
} from '../types/commercialTransactions';
import store from '../../store';
import { ifscRegex } from '../../utils/constants';
import { fetchIFSCDetails } from './nct';
import {
    STPAPIRequestType,
    STPAPIResponseType,
} from '../../components/dashboard/commercial/STP/types';
import {
  SipCancelReasonsResponseType,
    SipResponseType,
    SIPSubmitRequestType,
    SIPSubmitResponseType,
    SipTransactionRequestType,
    SipTransactionResponseType,
    SIPValidateRequestType,
    SIPValidationResponseType,
} from '../../components/dashboard/commercial/Sip/types';
import { OTMCancelRequestType } from '../../components/dashboard/commercial/emandate/types';

export const getFundTransactionInfo =
    (isin: string) =>
        async (dispatch: any): Promise<any> => {
            try {
                return await dispatch({
                    [CALL_API]: {
                        url: '/feed/schemeDetail',
                        method: 'POST',
                        types: [FETCH_FUND_TRANSACTION_DETAILS_SUCCESS, FETCH_FUND_TRANSACTION_DETAILS],
                        body: { isin },
                        // enableFixture: true,
                        // json: `fundPurchaseInfo.json`,
                    },
                });
            } catch (err: any) {
                throw err;
            }
        };

export const getInvestorLatestDetails =
    () =>
        async (dispatch: any): Promise<any> => {
            try {
                const {
                    body: { success },
                } = await dispatch({
                    [CALL_API]: {
                        url: '/user/getInvestorLatestDetails',
                        method: 'POST',
                        types: [
                            GET_INVESTOR_LATEST_DETAILS_SUCCESS,
                            GET_INVESTOR_LATEST_DETAILS,
                            GET_INVESTOR_LATEST_DETAILS_FAILED,
                        ],
                        // enableFixture: true,
                        // json: 'investorDetails.json',
                    },
                });
                if (success.length > 0) {
                    const bankDetails = success[0]?.bank?.[0];
                    if (!bankDetails.ifsc.match(ifscRegex)) {
                        return success;
                    }
                    if (
                        !bankDetails.branch ||
                        !bankDetails.city ||
                        !bankDetails.name ||
                        !bankDetails.micr
                    ) {
                        const {
                            body: {
                                data: [
                                    { BankAdd1, BankAdd2, BankAdd3, BankName, BankCity, MicrNo },
                                    ...rest
                                ],
                            },
                        } = (await dispatch(fetchIFSCDetails({ ifscCode: bankDetails.ifsc }))) as any;
                        const newBankDetails = {
                            ...bankDetails,
                            name: BankName,
                            branch: BankAdd1 || BankAdd2 || BankAdd3,
                            micr: MicrNo,
                            city: BankCity,
                        };
                        success[0].bank[0] = newBankDetails;
                        await dispatch({
                            type: GET_INVESTOR_LATEST_DETAILS_SUCCESS,
                            body: { success },
                        });
                    }
                }
                return success;
            } catch (err: any) {
                throw err;
            }
        };

export const redeemScheme =
    (body: any) =>
        async (dispatch: any): Promise<any> => {
            try {
                const { newPurchase } = store.getState();
                const {
                    kycVerified: { value },
                } = newPurchase;
                return await dispatch({
                    [CALL_API]: {
                        url: '/ft/redeem',
                        method: 'POST',
                        types: [REDEEM_SCHEME_SUCCESS, REDEEM_SCHEME],
                        body: {
                            ...body,
                            data: [
                                {
                                    ...((body?.data || [])[0] || {}),
                                    // kycStatus: value === null ? IsAllow.No : value,
                                },
                            ],
                        },
                    },
                });
            } catch (err: any) {
                throw err;
            }
        };
export const switchScheme =
    (body: any) =>
        async (dispatch: any): Promise<any> => {
            try {
                const { newPurchase } = store.getState();
                const {
                    kycVerified: { value },
                } = newPurchase;
                return await dispatch({
                    [CALL_API]: {
                        url: '/ft/switch',
                        method: 'POST',
                        body: {
                            ...body,
                            data: [
                                {
                                    ...((body?.data || [])[0] || {}),
                                    // kycStatus: value === null ? IsAllow.No : value,
                                },
                            ],
                        },
                        types: [SWITCH_SCHEME_SUCCESS, SWITCH_SCHEME],
                    },
                });
            } catch (err: any) {
                throw err;
            }
        };

export const getNewSchemeDetail =
    ({ isin, amcCode = '' }: schemeDetailsRequestType) =>
        async (dispatch: any): Promise<schemeDetailsResponseType> => {
            try {
                return await dispatch({
                    [CALL_API]: {
                        url: '/feed/rtaSchemeDetail',
                        method: 'POST',
                        body: { isin, amcCode },
                        types: [RTA_SCHEME_DETAIL_SUCCESS],
                        // enableFixture: true,
                        // json: 'schemeDetailNew.json',
                    },
                });
            } catch (err: any) {
                throw err;
            }
        };
export const getKycRegistrationLink =
    ({ isin, amc = '' }: { isin: String, amc: String }) =>
        async (dispatch: any): Promise<{ redirectUrl: String }> => {
            try {
                return await dispatch({
                    [CALL_API]: {
                        url: '/ft/kycRegister',
                        method: 'POST',
                        body: { isin, amc },
                        types: ['GET_KYC_REGISTRATION_URL',],
                        json: 'kycRedirectResponse.json',
                        // enableFixture: true,
                    },
                });
            } catch (err: any) {
                throw err;
            }
        };
export const getSipSummary = async (dispatch: any): Promise<SipResponseType> => {
    try {
        return await dispatch({
            [CALL_API]: {
                url: '/user/getSipSummary',
                method: 'POST',
                body: { amc: '' },
                types: [SIP_SUMMARY_SUCCESS, SIP_SUMMARY],
                enableFixture: false,
                json: 'sipSummary.json',
            },
        });
    } catch (err: any) {
        throw err;
    }
};

export const getSipCancelReasons = async (dispatch: any): Promise<SipCancelReasonsResponseType> => {
    try {
        return await dispatch({
            [CALL_API]: {
                url: '/user/getSIPCancelReasons',
                method: 'POST',
                types: [SIP_CANCEL_REASON_SUCCESS, SIP_CANCEL_REASON],
                enableFixture: false,
                json: 'sipCancelReasons.json',
            },
        });
    } catch (err: any) {
        throw err;
    }
};

export const getSipTransactionDetails =
    (body: SipTransactionRequestType) =>
        async (dispatch: any): Promise<SipTransactionResponseType> => {
            try {
                return await dispatch({
                    [CALL_API]: {
                        url: '/user/getSipDetail',
                        method: 'POST',
                        body,
                        types: [SIP_TRANSACTION_SUCCESS, SIP_TRANSACTION],
                        // enableFixture: true,
                        json: 'sipTransactionDetails.json',
                    },
                });
            } catch (err: any) {
                throw err;
            }
        };

export const makeSTPTransaction =
    (body: STPAPIRequestType) =>
        async (dispatch: any): Promise<STPAPIResponseType> => {
            try {
                return await dispatch({
                    [CALL_API]: {
                        url: '/ft/registerStp',
                        method: 'POST',
                        body,
                        types: [STP_TRANSACTION_SUCCESS, STP_TRANSACTION],
                        // enableFixture: true,
                        // json: 'stptransaction.json',
                    },
                });
            } catch (err: any) {
                throw err;
            }
        };

export const makeSWPTransaction =
    (body: STPAPIRequestType) =>
        async (dispatch: any): Promise<STPAPIResponseType> => {
            try {
                return await dispatch({
                    [CALL_API]: {
                        url: '/ft/registerSwp',
                        method: 'POST',
                        body,
                        types: [STP_TRANSACTION_SUCCESS, STP_TRANSACTION],
                        // enableFixture: true,
                        // json: 'stptransaction.json',
                    },
                });
            } catch (err: any) {
                throw err;
            }
        };
export const makeSIPValidation =
    (body : SIPValidateRequestType) =>
    async (dispatch: any): Promise<SIPValidationResponseType> => {
        try {
            return await dispatch({
                [CALL_API]: {
                    url: '/nft/validateSipPauseCancel',
                    method: 'POST',
                    body,
                    types: [SIP_VALIDATION_SUCCESS, SIP_VALIDATION],
                    enableFixture: false,
                    json: 'sipPauseValidate.json',
                },
            });
        } catch (err: any) {
            throw err;
        }
    };
export const submitSipPause=
    (body : SIPSubmitRequestType) =>
    async (dispatch: any): Promise<SIPSubmitResponseType> => {
        try {
            return await dispatch({
                [CALL_API]: {
                    url: '/nft/submitSipPauseCancel',
                    method: 'POST',
                    body,
                    types: [SIP_SUBMIT_SUCCESS, SIP_SUBMIT],
                    // enableFixture: true,
                    json: 'sipPauseCancel.json',
                },
            });
        } catch (err: any) {
            throw err;
        }
    };

export const otmCancel =
    (body: OTMCancelRequestType) =>
    async (dispatch: any): Promise<any> => {
        try {
            return await dispatch({
                [CALL_API]: {
                    url: '/nft/submitOtmCancel',
                    method: 'POST',
                    body,
                    types: [OTM_CANCEL_API_SUCCESS , OTM_CANCEL_API],
                    // enableFixture: true,
                    // json: 'stptransaction.json',
                },
            });
        } catch (err: any) {
            throw err;
        }
    };
